__turbopack_context__.v({
  "ant-card-body": "vtFV5G_ant-card-body",
  "ant-collapse-item": "vtFV5G_ant-collapse-item",
  "btn": "vtFV5G_btn",
  "collapsibleList": "vtFV5G_collapsibleList",
  "faq-group": "vtFV5G_faq-group",
  "faq-group-title": "vtFV5G_faq-group-title",
  "faqfooter": "vtFV5G_faqfooter",
  "fav-question-arrow": "vtFV5G_fav-question-arrow",
  "fav-question-expandright": "vtFV5G_fav-question-expandright",
  "fav-question-group": "vtFV5G_fav-question-group",
  "fav-question-list": "vtFV5G_fav-question-list",
  "fav-question-title": "vtFV5G_fav-question-title",
  "header": "vtFV5G_header",
  "page-body-wrap": "vtFV5G_page-body-wrap",
  "paragraph": "vtFV5G_paragraph",
  "title": "vtFV5G_title",
});
